import { gateway } from "./clients/baseClient";
import { ENDPOINTS } from "./endpoints/index";
import { ResponseData } from "./types/api";
import makeApiRequest from "./clients/apiRequest";
import { versionApiPath } from "./common";
import {
  ReticulationCreateReqBody,
  ReticulationCreateReqData,
  ReticulationPageReqBody,
  ReticulationPageReqData,
  ReticulationUpdateReqBody,
  ReticulationUpdateReqData,
} from "./types/reticulation";

export async function reticulationPage(
  body: ReticulationPageReqBody
): Promise<ResponseData> {
  const data: ReticulationPageReqData = {
    endpoint: `${versionApiPath}/${ENDPOINTS.RETICULATION.PAGE}`,
    body: body,
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    false
  );
}

export async function reticulationList(): Promise<ResponseData> {
  const data = {
    endpoint: `${versionApiPath}/${ENDPOINTS.RETICULATION.LIST}`,
    body: {},
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    false
  );
}

export async function addReticulation(
  body: ReticulationCreateReqBody
): Promise<ResponseData> {
  const data: ReticulationCreateReqData = {
    endpoint: `${versionApiPath}/${ENDPOINTS.RETICULATION.CREATE}`,
    body: body,
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    true
  );
}

export async function updateReticulation(
  body: ReticulationUpdateReqBody
): Promise<ResponseData> {
  const data: ReticulationUpdateReqData = {
    endpoint: `${versionApiPath}/${ENDPOINTS.RETICULATION.UPDATE}`,
    body: body,
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    true
  );
}

export async function getReticulation(id: string): Promise<ResponseData> {
  const data = {
    endpoint: `${versionApiPath}/${ENDPOINTS.RETICULATION.GET}`,
    body: { id: id },
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    true
  );
}

export async function deleteReticulation(id: string): Promise<ResponseData> {
  const data = {
    endpoint: `${versionApiPath}/${ENDPOINTS.RETICULATION.DELETE}`,
    body: { id: id },
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    true
  );
}
